export default "__VITE_ASSET__c072db83__"